// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FileCodeIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from file-code.svg
 */
export default function FileCodeIcon(props: FileCodeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FileCodeIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M12.685.144A.5.5 0 0 0 12.333 0H1.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V2.643a.5.5 0 0 0-.148-.356zM2 1h9v2.5a.5.5 0 0 0 .5.5H14v11H2zm4.53 4.47a.75.75 0 0 1 .073.976l-.073.084L5.061 8l1.47 1.47a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073-2-2a.75.75 0 0 1-.073-.976l.073-.084 2-2a.75.75 0 0 1 1.06 0m4 0-.084-.073a.75.75 0 0 0-1.049 1.05l.073.083L10.939 8l-1.47 1.47-.08.094a.75.75 0 0 0 .008.882l.073.084.094.08a.75.75 0 0 0 .882-.007l.084-.073 2-2 .08-.094a.75.75 0 0 0-.007-.882l-.073-.084z"
        />
      </g>
    </svg>
  );
}
